export default __webpack_public_path__ + "moderate-signal-icon.png";